import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { Company } from '@shared/models';

@Component({
  selector: 'mojo-company-card',
  templateUrl: './company-card.component.html',
  styleUrls: ['./company-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyCardComponent {
  @Input() company: Company;
  @Input() markedSearchPhrase: string;
  avatarShape = AvatarShapes.circle;
  avatarBackgroundSize = AvatarBackgroundSizes.cover;
}
